import React from 'react'
import family from "../img/family2.jpg";
import family1 from "../img/family3.jpg";
import family2 from "../img/family4.jpg";
import family3 from "../img/family5.jpg";

export default function Family() {
  return (
    <div>
      <section className="bg-primary position-relative py-5"> <br/>
        <div className="d-none d-dark-mode-block position-absolute top-0 start-0 w-100 h-100" ></div>
        <div className="container dark-mode position-relative zindex-2 py-5 mb-4 mb-sm-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
          <div className="row pb-5 mb-2 mb-sm-0 mb-lg-3">
            <div className="">
              <h1 className="display-4 pb-2 pb-sm-3">Семейный коучинг</h1>
              <p className='display-6'>представляет собой специализированную форму поддержки и сопровождения семей, направленный на улучшение взаимоотношений между членами семьи, разрешение конфликтов и достижение гармонии в семейной жизни.</p>
              <ul className="list-unstyled d-flex flex-wrap mb-0">
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Сохраняет семейные отношения</li>
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Восполняет поддержку</li>
                {/* <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Взаимапомощь</li> */}
                <li className="d-flex py-1 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Помогает семье улучшить свою жизнь</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* About*/}
      <section className="container position-relative zindex-3" style={{marginTop: '-135px'}}>
        <div className="rounded-5 overflow-hidden"> 
          <div className="jarallax ratio ratio-16x9" datajarallax dataspeed="0.6">
            <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/family1.jpg)'}}></div>
          </div>
        </div>
        <div className="row pt-5 mt-n2 mt-sm-0 mt-md-2 mt-lg-4 mt-xl-5">
          <div className="col-md-6 col-lg-5">
            <div className="fs-sm text-uppercase mb-3">Мы понимаем!</div>
            <h3 className="mb-lg-4">Семья важна!</h3>
            <h5 className="mb-lg-4">Этот вид коучинга особенно полезен в периоды кризисов, изменений или просто для поддержания здоровых и продуктивных отношений внутри семьи.</h5>
            <h4 className="mb-lg-4 fs-xl"><strong>Преимущества семейного коучинга: </strong> </h4>
            <ul className="list-unstyled fs-lg">
              <li className="d-flex align-items-start py-2">
                <i className="ai-check text-success me-2 mt-1"></i>
                <div className="flex-grow-1">
                  <strong className="d-block">Укрепление семейных связей:</strong>
                   <p className="mt-2 mb-0">Семейный коучинг помогает восстановить утраченное доверие и уважение между членами семьи.</p>
                </div>
              </li>
              <li className="d-flex align-items-start py-2">
                <i className="ai-check text-success me-2 mt-1"></i>
                <div className="flex-grow-1">
                  <strong className="d-block">Разрешение конфликтов:</strong>
                  <p className="mt-2 mb-0">Коуч выступает посредником в сложных ситуациях, помогая сторонам услышать друг друга и прийти к согласию.</p>
                </div>
                </li>
                <li className="d-flex align-items-start py-2">
                  <i className="ai-check text-success me-2 mt-1"></i>
                    <div className="flex-grow-1">
                      <strong className="d-block">Повышение осознанности:</strong>
                      <p className="mt-2 mb-0">Участники учатся лучше понимать свои собственные эмоции и мотивы, а также учитывать чувства и потребности других членов семьи.</p>
                    </div>
                </li>
                <li className="d-flex align-items-start py-2">
                  <i className="ai-check text-success me-2 mt-1"></i>
                    <div className="flex-grow-1">
                      <strong className="d-block">Планирование совместного будущего:</strong>
                      <p className="mt-2 mb-0">Коучинг помогает семье сформировать общую картину желаемого будущего и разработать план действий для его достижения.</p>
                    </div>
                </li>
                <li className="d-flex align-items-start py-2">
                  <i className="ai-check text-success me-2 mt-1"></i>
                  <div className="flex-grow-1">
                    <strong className="d-block">Создание поддерживающей среды:</strong>
                    <p className="mt-2 mb-0">Атмосфера доверия и понимания, созданная во время коуч-сессий, становится основой для дальнейшей здоровой коммуникации и сотрудничества.</p>
                  </div>
                </li>
            </ul>
          </div>
          <div className="container col-md-7 col-xl-6 pt-1 pt-sm-2 pt-md-5">
            <p className="fs-xl"><strong>Основные аспекты семейного коучинг: </strong></p>
            <ol className="fs-xl mb-0">
            <li ><strong>Диагностика ситуации:</strong> Коуч работает с семьей, чтобы выявить основные проблемы и трудности, которые возникают в отношениях. Это может включать обсуждение ожиданий, страхов, неудовлетворенности и других аспектов, влияющих на динамику семейных взаимодействий. </li>
            <li ><strong>Анализ личных убеждений: </strong> Часто конфликты в семье связаны с устоявшимися стереотипами и убеждениями, которые мешают гармоничному общению. Коуч помогает членам семьи осознать эти убеждения и найти способы их изменения или адаптации. </li>
            <li ><strong>Стратегия развития отношений: </strong> Совместно с участниками процесса коуч разрабатывает индивидуальную стратегию улучшения отношений. Эта стратегия включает конкретные шаги и рекомендации, которые помогут укрепить семейные связи и улучшить взаимопонимание.</li>
            <li ><strong>Перспектива будущего: </strong> Одним из важных элементов семейного коучинга является взгляд в будущее. Коуч помогает участникам определить общие цели и ценности, которые будут способствовать укреплению семьи и поддержанию позитивной динамики.</li>
            <li ><strong> Гармонизация и баланс: </strong> Создание атмосферы доверия и уважения внутри семьи — ключевая задача коуча. Он помогает участникам научиться конструктивно выражать свои чувства и потребности, находить компромиссы и решать возникающие разногласия мирным путем.</li>
            </ol>      
          </div>
        </div>
      </section>
      {/* Approach*/}
      <section className="container">
        <div className="pt-2 pt-sm-4 pt-lg-5 mt-xxl-2">
          <div className="fs-sm text-uppercase mb-3">Наша миссия</div>
          <p className='fs-xl'>Семейный коучинг — это эффективный инструмент для тех, кто стремится к улучшению отношений в семье и хочет создать гармонию и стабильность в своем доме. Профессиональный коуч поможет вам разобраться в сложностях, наладить общение и выстроить прочные основы для дальнейшего совместного пути.</p>
        <div className="container py-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            <div className="col">
              <div className="mb-4">
              <img className="rounded-5" src={family} alt="Ima"/>
                  <p></p>

                     <div className="mb-4">
              <img className="rounded-5" src={family1} alt="Ima"/>
            </div>
            </div>
         </div>
        <div className="col">
             <div className="mb-4">
              <img className="rounded-5" src={family3} alt="Ima"/>
            </div>
         </div>
         <div className="col">
             <div className="mb-4">
              <img className="rounded-5" src={family2} alt="Ima"/>
            </div>
         </div>
      </div>
      </div>
    </div>
    </section>
    
        <div className="d-flex justify-content-lg-end flex-column-reverse align-items-center">
          <div className="border rounded-5 col-lg-6 order-lg-2">
            <blockquote className="blockquote bg-light m-2 py-4 px-5 mb-0">
              <p className="mb-0 fs-lg">Добрый вечер, Анна! <br/> Даю обратную связь! Спасибо за ваше время и внимание ко мне.
              Всё расставили по местам с Петей. Всё расставила по местам со своими друзьями.
              Масштабный переворот, сейчас осталось сохранить и удержать это всё. <br/>И поддерживающая среда сразу кругом</p>
              <footer className="blockquote-footer text-primary d-flex justify-content-lg-end">Татьяна</footer>
            </blockquote>
          </div>
          {/* <div className="col-lg-6 order-lg-1">
            <div className="d-flex justify-content-lg-end">
              <a className="text-primary fw-bold" href="https://vk.com/topic-185666573_49682444">
                <i className="ai-arrow-right"></i>  <span className="ms-2">Вот, что пишут наши клиенты</span>
              </a>
            </div>
          </div> */}
        </div>
       <section className="container py-5">
          <h3 className=" mb-lg-4">Расписание необходимо уточнять у администратора. 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/formatyou72"><i className="ai-telegram text-success"> </i> </a>
           <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/developskillsnow"><i className="ai-instagram text-warning"> </i> </a> 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/thormayou"><i className="ai-vk text-danger"> </i> </a> 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/developskillsnow"><i className="ai-vk text-primary"> </i> </a> 
             </h3>
          <p className="fs-lg">
            Необходима предварительная запись по телефону:  +7 (992) 300-65-23, +7 (992) 300-65-46.  </p>
          <div>
           <h4 className="">Ждем вас на наших мероприятиях!</h4>
         {/* <br/> */}
          </div>
      </section>
    </div>
  )
}
